export default "__VITE_ASSET__mW_QSspV__"